module.exports = "<nav-bar></nav-bar>\r\n<app-product-profile *ngIf=\"type == 'product'\" [username]=\"username\"></app-product-profile>\r\n<app-user *ngIf=\"type == 'user'\" [username]=\"username\"></app-user>\r\n<app-brand-profile *ngIf=\"type == 'brand'\" [username]=\"username\"></app-brand-profile>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/pages/entities/entities.component.html
// module id = ../../../../../src/app/pages/entities/entities.component.html
// module chunks = main